/**
 * @typedef {Object} ErrorManager
 *
 * @property {Object} ERROR_TYPES
 * @property {Object} ERROR_LEVELS
 * @property {{pending: boolean, unresolvedErrors: Object[]}} criticalErrors
 * @property {function} handleError
 * @property {function} resolveAllCriticalErrors
 */


/**
 * @typedef {Object} AppError
 *
 * @property {string} type
 * @property {Date} time
 * @property {string} message
 * @property {Object} data
 */


(function() {
    'use strict';

    angular.module( APP_ID )
        .factory( 'ErrorManager', [ '$injector', '$timeout', 'LoggerFactory', 'CONFIG',  ErrorManagerService ]);


    /**
     * Providing business logic to handle and process all encountered errors.
     *
     * @param {ng.auto.IInjectorService} $injector
     * @param {TimeoutService} TimeoutService
     * @param {LoggerFactory} LoggerFactory
     * @param {Object} CONFIG
     *
     * @returns {ErrorManager}
     */
    function ErrorManagerService(
        $injector,
        $timeout,
        LoggerFactory,
        CONFIG
    ){





        /* ===== PRIVATE MEMBERS ============================================ */


        /** @type {Logger} */
        var logger = LoggerFactory.createLogger( 'ErrorManagerService', false );


        /** @const */
        var ERROR_LEVELS = {
            CRITICAL: 'critical',
            MINOR:    'minor'
        };
        Object.freeze( ERROR_LEVELS );


        /** @const */
        var ERROR_TYPES = {
            UNKNOWN: {
                code:  -1,
                level: ERROR_LEVELS.MINOR
            },
            CMS_RESOURCE_NOT_FOUND: {
                code:  1,
                level: ERROR_LEVELS.CRITICAL
            },
            CMS_RESPONSE_MALFORMATTED: {
                code:  2,
                level: ERROR_LEVELS.CRITICAL
            },
            CMS_RESPONSE_FAILURE: {
                code:  3,
                level: ERROR_LEVELS.CRITICAL
            },
            INTERNATIONAL_API_ERROR: {
                code:  4,
                level: ERROR_LEVELS.MINOR
            }
        };
        Object.freeze( ERROR_TYPES );


        /** Errors leading to app's failure */
        var criticalErrors = {
            pending:            false,
            unresolvedErrors:   []
        };


        /** Serialised list of encountered errors. */
        var errorsList               = [];


        /** @type {ErrorManager} */
        var service = {
            // CONSTANTS
            ERROR_TYPES:              ERROR_TYPES,
            ERROR_LEVELS:             ERROR_LEVELS,

            // Public members
            criticalErrors:           criticalErrors,

            // Public methods
            handleError:              handleError,
            resolveAllCriticalErrors: resolveAllCriticalErrors
        };



        ////////////////////////////////////////////////////////////////////////

        return service; // Expose API

        ////////////////////////////////////////////////////////////////////////





        /* ===== PUBLIC METHODS ============================================= */


        /**
         * Handles an error based on the given `ERROR_TYPE_ID` and adds it
         * into `errorsList`.
         *
         * @param {string} msg
         * @param {string} ERROR_TYPE_ID
         * @param {Object} dataObject
         */
        function handleError( msg, ERROR_TYPE_ID, dataObject ){
            try {
                var errorType = ERROR_TYPES.hasOwnProperty( ERROR_TYPE_ID )
                        ? ERROR_TYPES[ ERROR_TYPE_ID ]
                        : ERROR_TYPES.UNKNOWN;

                var dataObject = dataObject || {};


                /** @type {AppError} */
                var error = {
                    type:    errorType,
                    time:    new Date(),
                    message: msg,
                    data:    dataObject
                };

                evaluateError( error );
                errorsList.push( error );
            } catch ( err ) {
                logger.error( 'Incoming error could not be handled properly: ', err );
            }
        }


        /** Marks all critical errors as resolved. */
        function resolveAllCriticalErrors() {
            criticalErrors.pending          = false;
            criticalErrors.unresolvedErrors = [];
        }





        /* ===== PRIVATE ATTRIBUTES ========================================= */


        /**
         * Processes {AppError} based on its internal type.
         *
         * @param {AppError} error
         */
        function evaluateError( error ) {
            if ( error.type.level === ERROR_LEVELS.CRITICAL ){
                // If it's #404-based error from Content API, redirect to the #404 page
                if ( error.hasOwnProperty( 'data' ) && error.data.hasOwnProperty( 'responseCode' ) && error.data.responseCode === '404' ) {
                    var $state = $injector.get( '$state' );
                    $timeout( function() { // Hack: $timeout is required to prevent infinite loop in production
                        $state.transitionTo( CONFIG.STATES.SERVER_NOT_FOUND, undefined, {
                            reload:   false,
                            location: false,
                            notify:   false, // State routing config *MUST BE* present to avoid infinite redirects
                            inherit:  false,
                        });
                    }, 0 );
                } else {
                    criticalErrors.pending = true;
                    criticalErrors.unresolvedErrors.push( error );
                }
            }

            // TODO: Add automatic error serialisation and POST into remote database
        }


    }
})();
